import { render, staticRenderFns } from "./MobileSavedCard.vue?vue&type=template&id=67a3c52d&"
import script from "./MobileSavedCard.vue?vue&type=script&lang=js&"
export * from "./MobileSavedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports